// Strings for the Loom caregiver page. The workflow cards take their type, step, state and detail
// strings from Workflows, and the rest of the cards and the messages use the Loom lead strings.
export default {
  LoadError: 'Could not load this caregiver from Loom. Check the link, or refresh to try again.',
  Tabs: {
    PROFILE: 'Profile',
    WORKFLOWS: 'Workflows',
    INVITATIONS: 'Invitations',
    CORRESPONDANCE: 'Communications',
    INTERVIEWS: 'Interviews',
    SCHEDULING: 'Schedule',
    CLIENTS: 'Clients',
  },
  Header: {
    LegacyRn: 'Legacy RN',
    NoLegacyRn: 'No legacy RN',
  },
  Workflows: {
    Empty: 'This caregiver has no workflows.',
    Type: {
      JOB_INVITATION: 'Job invitation',
    },
    Steps: {
      InvitationSent: 'Invitation sent',
      ContactingCaregiver: 'Contacting caregiver',
      Finished: 'Interview or closed',
      InterviewCompleted: 'Interview completed',
      Declined: 'Declined',
      Unreachable: 'Unreachable',
      Cancelled: 'Cancelled',
      Closed: 'Closed',
    },
    State: {
      NOT_STARTED: 'Not started',
      STARTING: 'Starting',
      AWAITING_CAREGIVER: 'Waiting on caregiver',
      CALL_BOOKED: 'Interview call booked',
      TEAM_REVIEW: 'Needs team review',
      IN_PROGRESS: 'In progress',
      COMPLETED: 'Interview completed',
      DECLINED: 'Declined',
      UNREACHABLE: 'Unreachable',
      CANCELLED: 'Cancelled',
      CLOSED: 'Closed',
    },
    Details: {
      Job: 'Job',
      City: 'City',
      Days: 'Days',
      Invitation: 'Invitation',
      FollowUps: 'Follow-ups sent',
      Closed: 'Invitation closed',
    },
  },
  Correspondance: {
    Empty: 'This caregiver has no messages. A conversation shows here after the caregiver replies to one of their workflows.',
  },
  Schedule: {
    NoLegacyRn: 'Loom reads shifts by legacy RN, and this caregiver has none, so there is no schedule.',
  },
  Invitations: {
    Empty: 'This caregiver has no job invitations.',
    LoadError: 'Could not load the invitations. Refresh to try again.',
    JobMissing: 'Job not found',
    OpenJob: 'Open job',
    Sent: 'Sent #{value}',
    Closed: 'Closed #{value}',
    Progress: 'Progress',
    Calls: {
      Title: 'Calls',
      Empty: 'No calls are booked.',
      Attempt: 'Call #{number}',
      BookedFor: 'Booked for #{value}',
      Placed: 'Placed #{value}',
      Finished: 'Finished #{value}',
      NotPlaced: 'Not placed',
      Note: 'Note: #{value}',
      Kind: {
        FIRST: 'First call',
        BOOKED: 'Booked call',
      },
      Result: {
        ANSWERED: 'Answered',
        NO_ANSWER: 'No answer',
        BUSY: 'Busy',
        FAILED: 'Failed',
        VOICEMAIL: 'Voicemail',
        WRONG_PERSON: 'Wrong person',
        DROPPED: 'Dropped',
        CANCELLED: 'Cancelled',
        DECLINED: 'Declined',
        CALLBACK_REQUESTED: 'Callback requested',
        OPEN: 'No result yet',
      },
    },
    Answers: {
      Title: 'Interview answers',
      Empty: 'No answers yet. Loom saves them when the interview is completed.',
      StartDate: 'Can start on time',
      TasksCannotDo: 'Tasks they cannot do',
      Languages: 'Languages',
      Location: 'Can work at the location',
      Considerations: 'Confirmed the considerations',
      Terms: 'About the pay and hours',
      None: 'None',
      Answer: {
        YES: 'Yes',
        NO: 'No',
        CONDITIONAL: 'With conditions',
      },
      Boolean: {
        true: 'Yes',
        false: 'No',
      },
      Level: {
        NATIVE: 'Native',
        FLUENT: 'Fluent',
        CONVERSATIONAL: 'Conversational',
        BASIC: 'Basic',
        NONE: 'None',
      },
    },
    FamilyAnswers: {
      Title: 'Family questions',
      NotAnswered: 'Not answered',
    },
  },
  Clients: {
    Empty: 'This caregiver has no clients.',
    ClientName: 'Client name',
  },
};
